import { breakpoints } from './breakpoints';
import type { BreakpointsKeys } from './types';

export const px2rem = (...size: number[]): string =>
  size.map((s) => `${s / 16}rem`).join(' ');

export const getBreakpointSize = (breakpoint: BreakpointsKeys) => {
  const dimension = breakpoints[breakpoint];
  return parseInt(dimension.match(/\d+/)![0], 10);
};

export function hexToRgb(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ].join(' ')
    : null;
}

export function hexToRgba(hex: string, opacity: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
        opacity,
      ].join(',')
    : null;
}

export const generateSpacings = (...multiplier: number[]) => {
  const BASE = 8;
  const MAX_SPACING = 20;
  if (multiplier.some((n) => n > MAX_SPACING || n < 0)) {
    throw Error(`Multiplier be between 1-${MAX_SPACING}.`);
  }
  return multiplier.map((i) => `${i * BASE}px`).join(' ');
};
